import { render, staticRenderFns } from "./InjuryTypes.vue?vue&type=template&id=39e76d3c&"
import script from "./InjuryTypes.vue?vue&type=script&lang=js&"
export * from "./InjuryTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports